import { Injectable } from '@angular/core';
import { BackEndService } from './backEnd.service';
import { appConfig } from '../config/app.config';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  public static version: number = 2.72;
  versionData: any;
  constructor(private backEnd: BackEndService) {
  }

  updateAppVersion(object: any) {
    let obj = {
      version_number: object.version,
      header: object.header,
      description: object.description
    }
    console.log(obj);
    this.backEnd.saveObject(appConfig.STORAGE_TABLE.APP_VERSION, obj);
  }

  async getLatestVersion() {
    const versionList: any = await this.backEnd.searchObject(
      appConfig.STORAGE_TABLE.APP_VERSION, [], 0, 1, 'created_at', true, undefined, undefined, undefined, true);
    console.log(versionList);
    if (versionList && versionList.length > 0) {
      this.versionData = versionList[0];
    }
  }

}